/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line
  console.log("this is custom js");

  function changeCross() {
    let btn = document.getElementById("header-cross-btn")
    let selectDiv = document.getElementById("header-country-list")
    document.onclick = ()=>{
        selectDiv.classList.remove("select-popout__list--visible")
    }
    btn.onclick = (e)=>{
      selectDiv.classList.add("select-popout__list--visible")
      e.stopPropagation()
    }
    let optDiv = document.getElementById("header-country-list")
    let opts = optDiv.getElementsByTagName("a")
    let input = document.getElementById("header-country-input")
    let form = document.getElementById("header-cross-form")
    for(let opt of opts){
      let submitValue = opt.getAttribute("data-value")
      opt.onclick = ()=>{
        input.value = submitValue
        form.submit()
      }
      
    }
  }
  changeCross()

  //popup drawer
  function bindOpenAndDrawer(){
    let drawers = document.getElementsByClassName("popup_drawer")
    for(let drawer of drawers){
      let btnForOpen = drawer.getElementsByClassName("out_content")[0]
      let drawerContent = drawer.getElementsByClassName("shadow")[0]
      let popupNode = drawerContent.cloneNode(true)

      btnForOpen.onclick = ()=>{
        popupNode.style.display = 'block'

        let closeBtn = popupNode.getElementsByClassName("closeBtn")[0]
        closeBtn.onclick = ()=>{
          document.body.removeChild(popupNode)
          document.body.style.overflow = "scroll"
        }
        
        document.body.style.overflow = "hidden"
        document.body.insertBefore(popupNode, document.body.children[0])
      }
      
    }
  }
  bindOpenAndDrawer()

  function setShowLine() {
    var textDivs = document.getElementsByClassName("textWrap");
    for (var oneTextDiv of textDivs) {
      var textWrap = oneTextDiv.getElementsByClassName("text")[0];
      var button = oneTextDiv.getElementsByClassName("mybtn")[0];

      if (textWrap.scrollHeight <= textWrap.clientHeight) {
        button.classList.add("noBtn");
      } else {
        button.classList.remove("noBtn");
      }
    }
  }
  setShowLine();

  function resizeInfeed() {
    var infeedDivs = document.getElementsByClassName(
      "instafeed-new-layout-container"
    );
    if (infeedDivs.length > 0) {
      var infeedDiv = infeedDivs[0];
      var wrapper = infeedDiv.getElementsByClassName(
        "instafeed-new-layout-wrapper"
      )[0];
      var items = infeedDiv.getElementsByClassName("instafeed-new-layout-item");
      if (infeedDiv.clientWidth <= 768) {
        infeedDiv.style.height = infeedDiv.style.width;
        wrapper.style.height = infeedDiv.style.width;

        for (var item of items) {
          item.style.width = infeedDiv.style.width;
          item.style.height = infeedDiv.style.width;
        }

        var buttons = infeedDiv.getElementsByTagName("button");
        buttons[0].onclick = () => {
          if (items.length <= 1) {
            return;
          }
          var curTransform = wrapper.style.transform;
          if (curTransform) {
            curTransform = parseFloat(
              curTransform.replace("translateX(", "").replace("px)", "")
            );
          } else {
            curTransform = 0;
          }
          if (curTransform >= 0) {
            wrapper.style.transform =
              "translateX(" +
              -infeedDiv.clientWidth * (items.length - 1) +
              "px)";
          } else {
            wrapper.style.transform =
              "translateX(" + (curTransform + infeedDiv.clientWidth) + "px)";
          }
        };

        buttons[1].onclick = () => {
          if (items.length <= 1) {
            return;
          }
          var curTransform = wrapper.style.transform;
          if (curTransform) {
            curTransform = parseFloat(
              curTransform.replace("translateX(", "").replace("px)", "")
            );
          } else {
            curTransform = 0;
          }
          if (curTransform <= -infeedDiv.clientWidth * (items.length - 1)) {
            wrapper.style.transform = "translateX(0)";
          } else {
            wrapper.style.transform =
              "translateX(" + (curTransform - infeedDiv.clientWidth) + "px)";
          }
        };
      }
    } else {
      setTimeout(resizeInfeed, 2000);
    }
  }
  setTimeout(resizeInfeed, 2000);

  window.onresize = function () {
    setShowLine();
    resizeInfeed();
  };
  window.addEventListener("scroll", function () {
    var scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    var stickyCards = document.getElementsByClassName("stickyCard");
    if (stickyCards.length > 0) {
      var sticky = stickyCards[0];
      var submitBtn = document.getElementsByClassName(
        "product__submit__buttons"
      )[0];
      var leftDiv = sticky.getElementsByClassName("stickyCardLeft")[0];
      var rightDiv = sticky.getElementsByClassName("stickyCardRight")[0];
      var footer = document.getElementsByClassName("section-footer")[0];
      if (window.innerWidth > 768) {
        sticky.style.top = "60px";
        sticky.style.bottom = "auto";
        leftDiv.style.display = "flex";
        rightDiv.style.width = "auto";
        var top = submitBtn.getBoundingClientRect().top;
        if (top < 60) {
          sticky.style.display = "flex";
        } else {
          sticky.style.display = "none";
        }
      } else {
        sticky.style.top = "auto";
        sticky.style.bottom = "0";
        leftDiv.style.display = "none";
        rightDiv.style.width = "100%";
        var top = submitBtn.getBoundingClientRect().top;
        var top2 = footer.offsetTop - footer.offsetHeight - 60;
        var top3 = scrollTop;
        if (top < 60 && top2 > top3) {
          sticky.style.display = "flex";
        } else {
          sticky.style.display = "none";
        }
      }
    }
  });

  //product imagae view
  function slideImage() {
    var slideDivs = document.getElementsByClassName("mySlideContainer");
    for (let slideDiv of slideDivs) {
      let dots = slideDiv.getElementsByClassName("dot");
      let images = slideDiv.getElementsByClassName("images")[0];
      dots[0].classList.add("active");

      let curIndex = 0;
      let allNum = dots.length;
      let startX = 0;
      let startY = 0;
      let endX = 0;
      let endY = 0;
      slideDiv.addEventListener("touchstart", (e) => {
        startX = e.changedTouches[0].clientX;
        startY = e.changedTouches[0].clientY;
        e.preventDefault();
      });
      slideDiv.addEventListener("touchend", (e) => {
        endX = e.changedTouches[0].clientX;
        endY = e.changedTouches[0].clientY;
        let changeX = endX - startX;
        let changeY = endY - startY;
        if (Math.abs(changeX) < 10 && Math.abs(changeY) < 10) {
          slideDiv.click();
        }
        if (Math.abs(changeX) > Math.abs(changeY)) {
          let curTransform = images.style.transform;
          if (curTransform) {
            curTransform = parseFloat(
              curTransform.replace("translateX(", "").replace("px)", "")
            );
            curIndex = -parseInt(curTransform / 100)
          } else {
            curTransform = 0;
            curIndex = 0;
          }
          if (changeX > 0) {
            if (curIndex > 0) {
              curTransform += 100;
              images.style.transform = "translateX(" + curTransform + "%)";
              dots[curIndex].classList.remove("active");
              curIndex -= 1;
              dots[curIndex].classList.add("active");
            }
          } else if (changeX < 0) {
            if (curIndex < allNum - 1) {
              curTransform -= 100;
              images.style.transform = "translateX(" + curTransform + "%)";
              dots[curIndex].classList.remove("active");
              curIndex += 1;
              dots[curIndex].classList.add("active");
            }
          }
        }
      });
      // slideDiv.addEventListener("touchmove", (e)=>{
      //   console.log(e)

      // })
    }
  }
  slideImage();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
